import { render, staticRenderFns } from "./FirmInvoicingModalities.vue?vue&type=template&id=71f6d9b5"
import script from "./FirmInvoicingModalities.vue?vue&type=script&lang=js"
export * from "./FirmInvoicingModalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports